/*  Fear & Greed Index — v7.1.7 (patch: needle + titles + dates)
 *  Требования: Chart.js 4.x
 *  Контейнер: <div id="wp-fgi" data-lang="ru"></div>
 */

import '../../scss/parts/fgi.scss';
import Chart from 'chart.js/auto';

document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("wp-fgi");
  if (!root) return;

  const lang = root.dataset.lang || "ru";
  const FGI_CONFIG = window.CRYPTONISATION_FGI || {};

  /* =================== i18n =================== */
  const i18n = {
    ru: {
      chartTitle: "Цены ETH и BTC (USD)",
      index: "Индекс страха и жадности",
      price: "Цена",
      history: "Исторические значения",
      maxmin: "Годовой максимум и минимум",
      periods: { "7d": "7д", "1m": "1м", "6m": "6м", "1y": "1г" },
      labels: {
        yesterday: "Вчера",
        week: "Неделю назад",
        month: "Месяц назад",
        yHigh: "Годовой максимум",
        yLow: "Годовой минимум",
      },
      monthsShort: [
        "янв",
        "фев",
        "мар",
        "апр",
        "май",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
      states: {
        extreme_fear: {
          title: "Экстремальный страх",
          desc: "На рынке царит паника: инвесторы массово продают активы, цены падают ниже реальной стоимости",
        },
        fear: {
          title: "Страх",
          desc: "Преобладает осторожность: участники не спешат покупать, ждут сигналов и боятся новых падений",
        },
        neutral: {
          title: "Нейтрально",
          desc: "Баланс сил: рынок спокоен, цены колеблются без выраженного тренда",
        },
        greed: {
          title: "Жадность",
          desc: "Уверенность в росте: инвесторы активно покупают, возрастает эффект FOMO",
        },
        extreme_greed: {
          title: "Экстремальная жадность",
          desc: "Эйфория и перегрев: большинство уверено в бесконечном росте, цены завышены и риск коррекции максимален",
        },
      },
    },
    en: {
      chartTitle: "ETH and BTC Prices (USD)",
      index: "Fear & Greed Index",
      price: "Price",
      history: "Historical Values",
      maxmin: "Yearly Highs & Lows",
      periods: { "7d": "7d", "1m": "1m", "6m": "6m", "1y": "1y" },
      labels: {
        yesterday: "Yesterday",
        week: "A Week Ago",
        month: "A Month Ago",
        yHigh: "Yearly High",
        yLow: "Yearly Low",
      },
      monthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      states: {
        extreme_fear: {
          title: "Extreme Fear",
          desc: "Panic dominates: investors sell massively, prices fall below fair value",
        },
        fear: {
          title: "Fear",
          desc: "Caution prevails: participants hesitate to buy, waiting for signals and fearing new declines",
        },
        neutral: {
          title: "Neutral",
          desc: "Balance of forces: the market is calm, prices fluctuate without a clear trend",
        },
        greed: {
          title: "Greed",
          desc: "Confidence in growth: investors actively buy, FOMO increases",
        },
        extreme_greed: {
          title: "Extreme Greed",
          desc: "Euphoria and overheating: most expect endless growth, prices are overvalued and correction risk is maximal",
        },
      },
    },
    es: {
      chartTitle: "Precios ETH y BTC (USD)",
      index: "Índice de Miedo y Codicia",
      price: "Precio",
      history: "Valores Históricos",
      maxmin: "Máximos y Mínimos Anuales",
      periods: { "7d": "7d", "1m": "1m", "6m": "6m", "1y": "1a" },
      labels: {
        yesterday: "Ayer",
        week: "Hace una semana",
        month: "Hace un mes",
        yHigh: "Máximo anual",
        yLow: "Mínimo anual",
      },
      monthsShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
      states: {
        extreme_fear: {
          title: "Miedo extremo",
          desc: "Pánico en el mercado: ventas masivas y precios por debajo del valor real",
        },
        fear: {
          title: "Miedo",
          desc: "Predomina la cautela: se esperan señales y se temen nuevas caídas",
        },
        neutral: {
          title: "Neutral",
          desc: "Equilibrio de fuerzas: el mercado está tranquilo, sin tendencia clara",
        },
        greed: {
          title: "Codicia",
          desc: "Confianza en el alza: compras activas, aumenta el FOMO",
        },
        extreme_greed: {
          title: "Codicia extrema",
          desc: "Euforia y sobrecalentamiento: precios inflados, alto riesgo de corrección",
        },
      },
    },
    tr: {
      chartTitle: "ETH ve BTC Fiyatları (USD)",
      index: "Korku ve Açgözlülük Endeksi",
      price: "Fiyat",
      history: "Tarihi Değerler",
      maxmin: "Yıllık En Yüksek/En Düşük",
      periods: { "7d": "7g", "1m": "1a", "6m": "6a", "1y": "1y" },
      labels: {
        yesterday: "Dün",
        week: "Bir hafta önce",
        month: "Bir ay önce",
        yHigh: "Yıllık zirve",
        yLow: "Yıllık dip",
      },
      monthsShort: [
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara",
      ],
      states: {
        extreme_fear: {
          title: "Aşırı Korku",
          desc: "Panik hakim: toplu satışlar, fiyatlar gerçek değerinin altına iner",
        },
        fear: {
          title: "Korku",
          desc: "İhtiyat hakim: katılımcılar alımda acele etmiyor, düşüşten çekiniyor",
        },
        neutral: {
          title: "Nötr",
          desc: "Denge: piyasa sakin, belirgin trend yok",
        },
        greed: {
          title: "Açgözlülük",
          desc: "Yükseliş güveni: alımlar artıyor, FOMO yükseliyor",
        },
        extreme_greed: {
          title: "Aşırı Açgözlülük",
          desc: "Coşku ve aşırı ısınma: fiyatlar şişik, düzeltme riski yüksek",
        },
      },
    },
    ro: {
      chartTitle: "Prețurile ETH și BTC (USD)",
      index: "Indicele Fricii și Lăcomiei",
      price: "Preț",
      history: "Valori istorice",
      maxmin: "Maxime și minime anuale",
      periods: { "7d": "7z", "1m": "1l", "6m": "6l", "1y": "1a" },
      labels: {
        yesterday: "Ieri",
        week: "Acum o săptămână",
        month: "Acum o lună",
        yHigh: "Maxim anual",
        yLow: "Minim anual",
      },
      monthsShort: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ],
      states: {
        extreme_fear: {
          title: "Frică extremă",
          desc: "Panică pe piață: vânzări masive, prețuri sub valoarea reală",
        },
        fear: {
          title: "Frică",
          desc: "Prudență: investitorii așteaptă semnale, temându-se de noi scăderi",
        },
        neutral: {
          title: "Neutru",
          desc: "Echilibru: piața este liniștită, fără trend clar",
        },
        greed: {
          title: "Lăcomie",
          desc: "Încredere în creștere: achiziții active, crește FOMO",
        },
        extreme_greed: {
          title: "Lăcomie extremă",
          desc: "Euforie și supraîncălzire: prețuri supraevaluate, risc maxim de corecție",
        },
      },
    },
    pl: {
      chartTitle: "Ceny ETH i BTC (USD)",
      index: "Indeks Strachu i Chciwości",
      price: "Cena",
      history: "Wartości historyczne",
      maxmin: "Roczne maksima i minima",
      periods: { "7d": "7d", "1m": "1m", "6m": "6m", "1y": "1r" },
      labels: {
        yesterday: "Wczoraj",
        week: "Tydzień temu",
        month: "Miesiąc temu",
        yHigh: "Roczne maksimum",
        yLow: "Roczne minimum",
      },
      monthsShort: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "paź",
        "lis",
        "gru",
      ],
      states: {
        extreme_fear: {
          title: "Skrajny strach",
          desc: "Panika na rynku: masowa sprzedaż, ceny poniżej wartości",
        },
        fear: {
          title: "Strach",
          desc: "Ostrożność: uczestnicy czekają na sygnały, obawiają się spadków",
        },
        neutral: {
          title: "Neutralnie",
          desc: "Równowaga sił: rynek spokojny, bez wyraźnego trendu",
        },
        greed: {
          title: "Chciwość",
          desc: "Pewność wzrostu: aktywne zakupy, rośnie FOMO",
        },
        extreme_greed: {
          title: "Skrajna chciwość",
          desc: "Euforia i przegrzanie: ceny zawyżone, ryzyko korekty wysokie",
        },
      },
    },
  };

  /* ============== utils ============== */
  const t = i18n[lang] || i18n.ru;

  const COLOR_TOKENS = {
    red: "#FF5555",
    lightRed: "#FF8888",
    gray: "#C5D3E6",
    green: "#6CB46F",
    darkGreen: "#2D9431",
    gold: "#FFB500",
    bg: "#F5F7F8",
    bgAccent: "#E4ECF8",
    text: "#111827",
    textMuted: "#6B7280",
    textLight: "#9CA3AF",
    border: "#CDD6E5",
    grid: "#E4ECF8",
    white: "#FFFFFF",
    needle: "#8B909B",
    needleBase: "#6B7280",
  };

  const THRESHOLDS = {
    extremeFearMax: 24,
    fearMax: 44,
    neutralMax: 55,
    greedMax: 75,
    maxIndex: 100,
  };

  const UI = {
    gaugeHeight: 220,
    chartHeight: 360,
    needleCenterOffsetY: 6,
    needleLengthRatio: 0.56,
    needleBaseRadius: 6,
    needleHalfWidth: 3,
    chartBorderWidth: 2.4,
    chartTension: 0.35,
    barPercentage: 0.82,
    categoryPercentage: 0.9,
    chartXTickLimits: { "7d": 7, "1m": 8, default: 12 },
    refreshIntervalMs: 6 * 60 * 60 * 1000,
    dayMs: 24 * 60 * 60 * 1000,
  };

  const PERIOD_DAYS = { "7d": 7, "1m": 30, "6m": 180, "1y": 365 };

  const COIN_META = {
    bitcoin: {
      label: FGI_CONFIG.coins?.bitcoin?.label || "Bitcoin",
      symbol: FGI_CONFIG.coins?.bitcoin?.symbol || "BTC",
      thumbUrl: FGI_CONFIG.coins?.bitcoin?.thumb_url || "",
    },
    ethereum: {
      label: FGI_CONFIG.coins?.ethereum?.label || "Ethereum",
      symbol: FGI_CONFIG.coins?.ethereum?.symbol || "ETH",
      thumbUrl: FGI_CONFIG.coins?.ethereum?.thumb_url || "",
    },
  };

  const COIN_LABELS = {
    bitcoin: `${COIN_META.bitcoin.label} (${COIN_META.bitcoin.symbol})`,
    ethereum: `${COIN_META.ethereum.label} (${COIN_META.ethereum.symbol})`,
  };

  const CHART_PERIODS_WITH_DAY_LABELS = new Set(["7d", "1m"]);

  function getIndexTone(value) {
    if (value <= THRESHOLDS.extremeFearMax)
      return {
        className: "red",
        color: COLOR_TOKENS.red,
        state: t.states.extreme_fear,
      };
    if (value <= THRESHOLDS.fearMax)
      return {
        className: "lightred",
        color: COLOR_TOKENS.lightRed,
        state: t.states.fear,
      };
    if (value <= THRESHOLDS.neutralMax)
      return {
        className: "gray",
        color: COLOR_TOKENS.gray,
        state: t.states.neutral,
      };
    if (value <= THRESHOLDS.greedMax)
      return {
        className: "green",
        color: COLOR_TOKENS.green,
        state: t.states.greed,
      };
    return {
      className: "darkgreen",
      color: COLOR_TOKENS.darkGreen,
      state: t.states.extreme_greed,
    };
  }

  function daysByPeriod(period) {
    return PERIOD_DAYS[period] || PERIOD_DAYS["1y"];
  }

  function fmtDMY(time) {
    const d = new Date(time);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}.${mm}.${yy}`;
  }

  function fmtMonYY(time) {
    const d = new Date(time);
    const yy = String(d.getFullYear()).slice(-2);
    return `${t.monthsShort[d.getMonth()]}, ${yy}`;
  }

  function fmtDate(time) {
    const d = new Date(time);
    if (lang === "ru") {
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      return `${dd}.${mm}.${d.getFullYear()}`;
    }
    return `${t.monthsShort[d.getMonth()]}, ${String(d.getFullYear()).slice(-2)}`;
  }

  function formatTooltipDate(time) {
    const date = new Date(time);
    if (lang === "ru") {
      return `${date.getDate()} ${t.monthsShort[date.getMonth()]} ${date.getFullYear()}`;
    }
    return `${t.monthsShort[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }

  function cleanDesc(text) {
    if (!text) return "";
    let next = text;
    const parts = next.split(/—|–|-/);
    if (parts.length > 1) next = parts.slice(1).join(" ").trim();
    next = next.replace(/^[-–—]\s*/, "").trim();
    if (!next) return "";
    return next.charAt(0).toUpperCase() + next.slice(1);
  }

  function utcDayStart(time) {
    const d = new Date(time);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  function getErrorMessage() {
    const map = {
      ru: "Не удалось загрузить данные.",
      en: "Failed to load data.",
      es: "No se pudieron cargar los datos.",
      tr: "Veriler yuklenemedi.",
      ro: "Datele nu au putut fi incarcate.",
      pl: "Nie udalo sie zaladowac danych.",
    };
    return map[lang] || map.ru;
  }

  function getChartErrorMessage() {
    const map = {
      ru: "Не удалось загрузить данные графика.",
      en: "Failed to load chart data.",
      es: "No se pudieron cargar los datos del grafico.",
      tr: "Grafik verileri yuklenemedi.",
      ro: "Datele graficului nu au putut fi incarcate.",
      pl: "Nie udalo sie zaladowac danych wykresu.",
    };
    return map[lang] || map.ru;
  }

  function getNoDataMessage() {
    const map = {
      ru: "Нет данных",
      en: "No data",
      es: "Sin datos",
      tr: "Veri yok",
      ro: "Fara date",
      pl: "Brak danych",
    };
    return map[lang] || map.ru;
  }

  function assertFiniteNumber(value, label) {
    if (!Number.isFinite(value)) {
      throw new Error(`[FGI] Invalid number for ${label}`);
    }
    return value;
  }

  function alignDailySeries(indexSeries, priceSeries) {
    const priceByDay = new Map(
      priceSeries.map((point) => [utcDayStart(point.time), point.price]),
    );
    const aligned = [];
    for (const point of indexSeries) {
      const day = utcDayStart(point.time);
      if (!priceByDay.has(day)) continue;
      aligned.push({
        time: day,
        indexValue: point.value,
        price: priceByDay.get(day),
      });
    }
    if (!aligned.length) {
      throw new Error("[FGI] No overlapping daily data points for chart");
    }
    return aligned;
  }

  function getHistoryPoint(series, daysAgo) {
    if (!series.length) return null;
    const latest = series[series.length - 1];
    const targetTime = utcDayStart(latest.time - daysAgo * UI.dayMs);
    const pointByDay = new Map(
      series.map((point) => [utcDayStart(point.time), point]),
    );
    return pointByDay.get(targetTime) || null;
  }

  function renderStatItem(label, point) {
    if (!point) {
      return `<div class="stats-label">${label}</div><div class="stats-line">${getNoDataMessage()}</div>`;
    }
    const tone = getIndexTone(point.value);
    return `<div class="stats-label">${label}</div><div class="stats-line"><span class="value ${tone.className}">${point.value}</span>${tone.state.title}</div>`;
  }

  /* ============== layout ============== */
  root.innerHTML = `
    <section class="fgi-top">
      <div class="gauge-section">
        <div class="gauge-wrapper">
          <canvas id="gaugeCanvas"></canvas>
        </div>
        <div class="fgi-value">--</div>
        <div class="fgi-status gray">--</div>
        <div class="fgi-desc">${t.index}</div>
      </div>

      <div class="stats-section">
        <div class="stats-block">
          <div class="stats-group">
            <div class="stats-title">${t.history}</div>
            <div class="stats-item" id="h-yesterday"></div>
            <div class="stats-item" id="h-week"></div>
            <div class="stats-item" id="h-month"></div>
          </div>
          <div class="stats-group">
            <div class="stats-title">${t.maxmin}</div>
            <div class="stats-item" id="y-high"></div>
            <div class="stats-item" id="y-low"></div>
          </div>
        </div>
      </div>
    </section>

    <h2 class="fgi-heading">${t.chartTitle}</h2>

    <section class="chart-section" id="chartSection">
      <div class="chart-header">
        <div class="chart-controls" id="chartControls">
          <div class="timeframes">
            <button type="button" data-period="7d" class="timeframe">${t.periods["7d"]}</button>
            <button type="button" data-period="1m" class="timeframe">${t.periods["1m"]}</button>
            <button type="button" data-period="6m" class="timeframe">${t.periods["6m"]}</button>
            <button type="button" data-period="1y" class="timeframe active">${t.periods["1y"]}</button>
          </div>
        </div>
        <div class="chart-select" id="coinSelect">
          <button
            type="button"
            class="chart-select-trigger"
            aria-haspopup="listbox"
            aria-expanded="false"
            aria-labelledby="coinSelectValue"
          >
            <span class="chart-select-value" id="coinSelectValue">${getCoinOptionMarkup("bitcoin")}</span>
            <span class="chart-select-arrow" aria-hidden="true"></span>
          </button>
          <div class="chart-select-menu" role="listbox" tabindex="-1" aria-labelledby="coinSelectValue">${getCoinOptionsMarkup("bitcoin")}</div>
        </div>
      </div>
      <div class="chart-canvas-wrap">
        <canvas id="fgiChart"></canvas>
      </div>
      <div id="chartError" class="chart-error"></div>
      <div class="chart-legend">
        <span class="circle legend-index"></span> ${t.index}
        &nbsp;&nbsp;
        <span class="circle legend-price"></span> ${t.price}
      </div>
    </section>
  `;

  /* ============== API ============== */
  const dom = {
    gaugeCanvas: root.querySelector("#gaugeCanvas"),
    chartCanvas: root.querySelector("#fgiChart"),
    chartError: root.querySelector("#chartError"),
    chartLegend: root.querySelector(".chart-legend"),
    chartControls: root.querySelector("#chartControls"),
    coinSelect: root.querySelector("#coinSelect"),
    value: root.querySelector(".fgi-value"),
    status: root.querySelector(".fgi-status"),
    desc: root.querySelector(".fgi-desc"),
    historyYesterday: root.querySelector("#h-yesterday"),
    historyWeek: root.querySelector("#h-week"),
    historyMonth: root.querySelector("#h-month"),
    yearHigh: root.querySelector("#y-high"),
    yearLow: root.querySelector("#y-low"),
  };
  dom.coinSelectTrigger =
    dom.coinSelect?.querySelector(".chart-select-trigger") || null;
  dom.coinSelectMenu =
    dom.coinSelect?.querySelector(".chart-select-menu") || null;
  dom.coinSelectValue =
    dom.coinSelect?.querySelector(".chart-select-value") || null;
  const CLIENT_CACHE_KEY =
    FGI_CONFIG.storageKey || "cryptonisation_fgi_cache_v1";
  const CLIENT_CACHE_REVALIDATE_MS =
    FGI_CONFIG.clientCacheRevalidateMs || 15 * 60 * 1000;

  function getCoinOptionMarkup(coin) {
    const meta = COIN_META[coin] || COIN_META.bitcoin;
    const thumbMarkup = meta.thumbUrl
      ? `<img class="chart-select-thumb" src="${meta.thumbUrl}" alt="${meta.label}">`
      : `<span class="chart-select-thumb-fallback ${coin}" aria-hidden="true">${meta.symbol.charAt(0)}</span>`;

    return `
      ${thumbMarkup}
      <span class="chart-select-text">
        <span class="coin-name">${meta.label}</span>
        <span class="coin-symbol">(${meta.symbol})</span>
      </span>
    `;
  }

  function getCoinOptionsMarkup(selectedCoin) {
    return Object.keys(COIN_META)
      .map((coin) => {
        const isActive = coin === selectedCoin;
        return `
        <button type="button" class="chart-select-option${isActive ? " active" : ""}" role="option" data-value="${coin}" aria-selected="${isActive ? "true" : "false"}">
          ${getCoinOptionMarkup(coin)}
        </button>
      `;
      })
      .join("");
  }

  function getCoinOptions() {
    return Array.from(
      dom.coinSelect?.querySelectorAll(".chart-select-option") || [],
    );
  }

  function openCoinSelect() {
    if (!dom.coinSelect || !dom.coinSelectTrigger) return;
    dom.coinSelect.classList.add("open");
    dom.coinSelect.dataset.open = "true";
    dom.coinSelectTrigger.setAttribute("aria-expanded", "true");
  }

  function closeCoinSelect() {
    if (!dom.coinSelect || !dom.coinSelectTrigger) return;
    dom.coinSelect.classList.remove("open");
    dom.coinSelect.dataset.open = "false";
    dom.coinSelectTrigger.setAttribute("aria-expanded", "false");
  }

  function syncCoinSelect(selectedCoin) {
    const options = getCoinOptions();
    options.forEach((option) => {
      const isActive = option.dataset.value === selectedCoin;
      option.classList.toggle("active", isActive);
      option.setAttribute("aria-selected", isActive ? "true" : "false");
    });
    if (dom.coinSelectValue) {
      dom.coinSelectValue.innerHTML = getCoinOptionMarkup(selectedCoin);
    }
  }

  function selectCoin(nextCoin) {
    if (!nextCoin || nextCoin === currentCoin) {
      syncCoinSelect(currentCoin);
      closeCoinSelect();
      return;
    }
    currentCoin = nextCoin;
    syncCoinSelect(currentCoin);
    closeCoinSelect();
    void redrawChart();
  }

  function moveCoinSelection(step) {
    const options = getCoinOptions();
    if (!options.length) return;
    const currentIndex = options.findIndex(
      (option) => option.dataset.value === currentCoin,
    );
    const nextIndex =
      currentIndex === -1
        ? 0
        : (currentIndex + step + options.length) % options.length;
    selectCoin(options[nextIndex].dataset.value);
    dom.coinSelectTrigger?.focus();
  }

  function readClientCache() {
    try {
      const raw = window.localStorage?.getItem(CLIENT_CACHE_KEY);
      if (!raw) return null;

      const stored = JSON.parse(raw);
      if (!stored || typeof stored !== "object" || !stored.payload) {
        return null;
      }

      return {
        payload: stored.payload,
        widgetData: stored.payload,
        fetchedAt: Number(stored.fetchedAt) || 0,
      };
    } catch (error) {
      return null;
    }
  }

  function writeClientCache(payload) {
    try {
      window.localStorage?.setItem(
        CLIENT_CACHE_KEY,
        JSON.stringify({
          payload,
          fetchedAt: Date.now(),
        }),
      );
    } catch (error) {
      console.warn("[FGI] failed to write client cache", { error });
    }
  }

  function shouldRevalidateClientCache(storedCache) {
    if (!storedCache) return true;
    return Date.now() - storedCache.fetchedAt >= CLIENT_CACHE_REVALIDATE_MS;
  }

  async function fetchWidgetCache() {
    if (!FGI_CONFIG.cacheUrl) {
      throw new Error("[FGI] Cache URL is not configured");
    }

    const response = await fetch(FGI_CONFIG.cacheUrl, {
      method: "GET",
      credentials: "same-origin",
    });

    if (!response.ok) {
      throw new Error(
        `[FGI] Cache request failed with status ${response.status}`,
      );
    }

    const payload = await response.json();
    return {
      payload,
      widgetData: payload,
    };
  }

  /* ============== Gauge ============== */
  function setupHiDPICanvas(canvas, heightOverride) {
    if (!canvas) return null;
    const context = canvas.getContext("2d");
    if (!context) return null;

    const cssWidth =
      canvas.clientWidth || canvas.parentElement?.clientWidth || 0;
    const cssHeight = heightOverride || canvas.clientHeight || 0;
    if (!cssWidth || !cssHeight) return context;

    const dpr = Math.max(window.devicePixelRatio || 1, 1);
    const nextWidth = Math.round(cssWidth * dpr);
    const nextHeight = Math.round(cssHeight * dpr);

    if (canvas.width !== nextWidth) canvas.width = nextWidth;
    if (canvas.height !== nextHeight) canvas.height = nextHeight;

    if (typeof context.resetTransform === "function") {
      context.resetTransform();
    } else {
      context.setTransform(1, 0, 0, 1, 0, 0);
    }
    context.scale(dpr, dpr);

    return context;
  }

  function buildGaugeNeedlePlugin(value) {
    return {
      id: "needle",
      afterDraw(chart) {
        const meta = chart.getDatasetMeta(0);
        const arc = meta.data[0];
        if (!arc) return;

        const angle = -Math.PI / 2 + (value / THRESHOLDS.maxIndex) * Math.PI;
        const needleLength = Math.round(
          arc.outerRadius * UI.needleLengthRatio * 1.05,
        );
        const centerX = arc.x;
        const centerY = arc.y - UI.needleCenterOffsetY;

        const ctx = chart.ctx;

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate(angle);

        // --- ТРАПЕЦИЕВИДНАЯ ИГЛА С ЗАКРУГЛЕННЫМ КОНЧИКОМ ---
        const baseWidth = UI.needleHalfWidth * 2; // ширина у основания
        const tipWidth = baseWidth * 0.25; // ширина на конце (сильное сужение)
        const tipRadius = tipWidth * 0.6; // радиус скругления кончика

        // Игла начинается прямо от центра, основание перекроет стык
        const startY = -UI.needleBaseRadius * 0.8; // начинаем чуть выше центра основания
        const endY = -needleLength; // конец иглы

        ctx.beginPath();

        // Рисуем левую сторону с плавным сужением
        ctx.moveTo(-baseWidth / 2, startY);
        ctx.lineTo(-tipWidth / 2, endY);

        // Закругленный кончик (полукруг)
        ctx.quadraticCurveTo(0, endY + tipRadius, tipWidth / 2, endY);

        // Правая сторона
        ctx.lineTo(baseWidth / 2, startY);

        ctx.closePath();
        ctx.fillStyle = COLOR_TOKENS.needle;
        ctx.fill();

        // Круглое основание
        ctx.beginPath();
        ctx.arc(0, 0, UI.needleBaseRadius, 0, Math.PI * 2);
        ctx.fillStyle = COLOR_TOKENS.needleBase;
        ctx.fill();
        ctx.lineWidth = 2;
        ctx.strokeStyle = COLOR_TOKENS.white;
        ctx.stroke();

        ctx.restore();
      },
    };
  }

  function buildGaugeConfig(value) {
    const thinBorderPlugin = {
      id: "thinBorder",
      afterDraw(chart) {
        const { ctx } = chart;
        const meta = chart.getDatasetMeta(0);
        const arc = meta.data[0];

        if (!arc) return;

        ctx.save();
        ctx.beginPath();

        const centerX = arc.x;
        const centerY = arc.y;
        const outerRadius = arc.outerRadius * 0.69;
        const offset = (1 * Math.PI) / 180;
        const startAngle = -Math.PI + offset;
        const endAngle = 0 - offset;

        ctx.arc(centerX, centerY, outerRadius, startAngle, endAngle);

        ctx.strokeStyle = COLOR_TOKENS.gray;
        ctx.lineWidth = 1;
        ctx.stroke();

        ctx.restore();
      },
    };

    return {
      type: "doughnut",
      data: {
        labels: ["a", "b", "c", "d", "e"],
        datasets: [
          {
            data: [25, 20, 10, 20, 25],
            backgroundColor: [
              COLOR_TOKENS.red,
              COLOR_TOKENS.lightRed,
              COLOR_TOKENS.gray,
              COLOR_TOKENS.green,
              COLOR_TOKENS.darkGreen,
            ],
            borderWidth: 0,
            cutout: "70%",
            spacing: 16,
            borderRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        rotation: -90,
        circumference: 180,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        animation: false,
      },
      plugins: [buildGaugeNeedlePlugin(value), thinBorderPlugin],
    };
  }

  function buildChartDatasets(indexSeries, priceSeries, coin) {
    return [
      {
        type: "bar",
        label: t.index,
        data: indexSeries,
        backgroundColor(context) {
          return getIndexTone(context.raw).color;
        },
        borderWidth: 0,
        yAxisID: "y",
        order: 2,
        barPercentage: UI.barPercentage,
        categoryPercentage: UI.categoryPercentage,
      },
      {
        type: "line",
        label: `${t.price} ${COIN_LABELS[coin]}`,
        data: priceSeries,
        borderColor: COLOR_TOKENS.gold,
        borderWidth: UI.chartBorderWidth,
        pointRadius: 0,
        tension: UI.chartTension,
        yAxisID: "y1",
        order: 1,
      },
    ];
  }

  function buildChartOptions(indexSeries, times, period) {
    const maxTicks = UI.chartXTickLimits[period] || UI.chartXTickLimits.default;
    const formatTick = CHART_PERIODS_WITH_DAY_LABELS.has(period)
      ? (index) => fmtDMY(times[index])
      : (index) => fmtMonYY(times[index]);

    return {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: "nearest", intersect: false },
      devicePixelRatio: Math.max(window.devicePixelRatio || 1, 1),
      scales: {
        y: {
          min: 0,
          max: THRESHOLDS.maxIndex,
          grid: { color: COLOR_TOKENS.grid },
          ticks: { color: COLOR_TOKENS.textMuted, font: { size: 12 } },
        },
        y1: {
          position: "right",
          grid: { drawOnChartArea: false },
          ticks: {
            color: COLOR_TOKENS.textMuted,
            font: { size: 12 },
            callback(value) {
              return `$ ${Number(value).toLocaleString()}`;
            },
          },
        },
        x: {
          grid: { display: false },
          ticks: {
            color: COLOR_TOKENS.textLight,
            font: { size: 11 },
            autoSkip: true,
            maxTicksLimit: maxTicks,
            callback(value, index) {
              return formatTick(index);
            },
          },
        },
      },
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: true,
          mode: "nearest",
          intersect: false,
          backgroundColor: COLOR_TOKENS.white,
          titleColor: COLOR_TOKENS.text,
          bodyColor: COLOR_TOKENS.text,
          borderColor: "rgba(17,24,39,0.08)",
          borderWidth: 1,
          padding: 12,
          displayColors: false,
          boxPadding: 6,
          cornerRadius: 10,
          bodyFont: { size: 13 },
          titleFont: { size: 13, weight: "700" },
          filter(item) {
            return item.dataset.type === "line";
          },
          callbacks: {
            title(items) {
              if (!items?.length) return "";
              const item = items[0];
              const time =
                item.raw?.time || item.dataset.data[item.dataIndex]?.time;
              return time ? formatTooltipDate(time) : item.label || "";
            },
            label(item) {
              const indexValue = indexSeries[item.dataIndex];
              const priceValue = item.raw?.y ?? item.parsed?.y ?? item.raw;
              const indexWord = lang === "ru" ? "Индекс" : "Index";
              return [
                `${indexWord}: ${indexValue}`,
                `${t.price}: $ ${Number(priceValue).toLocaleString()}`,
              ];
            },
          },
        },
      },
      animation: false,
    };
  }

  function getChartData(alignedSeries) {
    return {
      labels: alignedSeries.map((point) => fmtDMY(point.time)),
      times: alignedSeries.map((point) => point.time),
      indexSeries: alignedSeries.map((point) => point.indexValue),
      priceSeries: alignedSeries.map((point) => ({
        x: point.time,
        y: point.price,
        time: point.time,
      })),
    };
  }

  let gaugeChart = null;
  let priceChart = null;
  let hasRenderedChart = false;
  let currentPeriod = "1y";
  let currentCoin = "bitcoin";
  let cachedWidgetData = null;
  let cachedFngYear = null;
  let cachedDailyPricesByCoin = new Map();

  function syncWidgetCache(widgetData) {
    cachedWidgetData = widgetData;
    cachedFngYear = widgetData.fear_greed ||
      widgetData.fearGreed || { latest: null, series: [] };
    const prices = widgetData.prices || { bitcoin: [], ethereum: [] };
    cachedDailyPricesByCoin = new Map(Object.entries(prices));
  }

  function renderGauge(value) {
    if (!dom.gaugeCanvas) return;
    setupHiDPICanvas(dom.gaugeCanvas, UI.gaugeHeight);
    if (gaugeChart) {
      gaugeChart.destroy();
      gaugeChart = null;
    }
    gaugeChart = new Chart(
      dom.gaugeCanvas.getContext("2d"),
      buildGaugeConfig(value),
    );
  }

  function renderChart(chartData, coin, period) {
    if (!dom.chartCanvas) return;
    setupHiDPICanvas(dom.chartCanvas, UI.chartHeight);
    if (priceChart) {
      priceChart.destroy();
    }
    priceChart = new Chart(dom.chartCanvas.getContext("2d"), {
      data: {
        labels: chartData.labels,
        datasets: buildChartDatasets(
          chartData.indexSeries,
          chartData.priceSeries,
          coin,
        ),
      },
      options: buildChartOptions(
        chartData.indexSeries,
        chartData.times,
        period,
      ),
    });
    hasRenderedChart = true;
  }

  function setChartStateError(message, preserveChart) {
    if (!preserveChart && priceChart) {
      priceChart.destroy();
      priceChart = null;
      hasRenderedChart = false;
    }
    if (dom.chartCanvas)
      dom.chartCanvas.style.display = preserveChart ? "block" : "none";
    if (dom.chartLegend)
      dom.chartLegend.style.display = preserveChart ? "block" : "none";
    if (dom.chartError) {
      dom.chartError.textContent = message;
      dom.chartError.classList.toggle("chart-error-inline", preserveChart);
      dom.chartError.style.display = preserveChart ? "block" : "flex";
    }
  }

  function clearChartStateError() {
    if (dom.chartCanvas) dom.chartCanvas.style.display = "block";
    if (dom.chartLegend) dom.chartLegend.style.display = "block";
    if (dom.chartError) {
      dom.chartError.textContent = "";
      dom.chartError.classList.remove("chart-error-inline");
      dom.chartError.style.display = "none";
    }
  }

  /* ======= Правый блок ======= */
  function fillHistory(series) {
    const yesterday = getHistoryPoint(series, 1);
    const week = getHistoryPoint(series, 7);
    const month = getHistoryPoint(series, 30);
    dom.historyYesterday.innerHTML = renderStatItem(
      t.labels.yesterday,
      yesterday,
    );
    dom.historyWeek.innerHTML = renderStatItem(t.labels.week, week);
    dom.historyMonth.innerHTML = renderStatItem(t.labels.month, month);
  }

  function fillYearExtremes(series) {
    const lastYear = series.slice(-365);
    if (!lastYear.length) {
      dom.yearHigh.innerHTML = `<div class="stats-label">${t.labels.yHigh}</div><div class="stats-line">${getNoDataMessage()}</div>`;
      dom.yearLow.innerHTML = `<div class="stats-label">${t.labels.yLow}</div><div class="stats-line">${getNoDataMessage()}</div>`;
      return;
    }

    let high = lastYear[0];
    let low = lastYear[0];
    for (const point of lastYear) {
      if (point.value > high.value) high = point;
      if (point.value < low.value) low = point;
    }

    const highTone = getIndexTone(high.value);
    const lowTone = getIndexTone(low.value);

    dom.yearHigh.innerHTML = `<div class="stats-label">${t.labels.yHigh}<span class="stats-date">${fmtDate(high.time)}</span></div><div class="stats-line"><span class="value ${highTone.className}">${high.value}</span>${highTone.state.title}</div>`;
    dom.yearLow.innerHTML = `<div class="stats-label">${t.labels.yLow}<span class="stats-date">${fmtDate(low.time)}</span></div><div class="stats-line"><span class="value ${lowTone.className}">${low.value}</span>${lowTone.state.title}</div>`;
  }

  function setSummaryStateError(message) {
    if (gaugeChart) {
      gaugeChart.destroy();
      gaugeChart = null;
    }
    if (dom.gaugeCanvas) {
      const ctx = setupHiDPICanvas(dom.gaugeCanvas, UI.gaugeHeight);
      ctx?.clearRect(0, 0, dom.gaugeCanvas.clientWidth || 0, UI.gaugeHeight);
    }
    dom.value.className = "fgi-value";
    dom.value.textContent = "--";
    dom.status.className = "fgi-status gray";
    dom.status.textContent = getNoDataMessage();
    dom.desc.textContent = message;
    fillHistory([]);
    fillYearExtremes([]);
  }

  function renderSummary(fngYear) {
    if (
      !fngYear ||
      !fngYear.latest ||
      typeof fngYear.latest.value === "undefined"
    ) {
      setSummaryStateError(getNoDataMessage());
      return;
    }

    const latestValue = parseInt(fngYear.latest.value, 10);
    const tone = getIndexTone(latestValue);

    dom.value.className = "fgi-value";
    dom.value.textContent = latestValue;
    dom.status.className = `fgi-status ${tone.className}`;
    dom.status.textContent = tone.state.title;
    dom.desc.textContent = cleanDesc(tone.state.desc);

    renderGauge(latestValue);
    fillHistory(Array.isArray(fngYear.series) ? fngYear.series : []);
    fillYearExtremes(Array.isArray(fngYear.series) ? fngYear.series : []);
  }

  function syncPeriodControls(activeButton) {
    dom.chartControls.querySelectorAll("button").forEach((button) => {
      button.classList.toggle("active", button === activeButton);
    });
  }

  function updateLegend(coin) {
    if (!dom.chartLegend) return;
    dom.chartLegend.innerHTML = `<span class="circle legend-index"></span> ${t.index} &nbsp;&nbsp;<span class="circle legend-price"></span> ${t.price} ${COIN_LABELS[coin]}`;
  }

  async function getWidgetData(forceRefresh) {
    if (!forceRefresh && cachedWidgetData) return cachedWidgetData;
    if (!forceRefresh) {
      const storedCache = readClientCache();
      if (storedCache) {
        syncWidgetCache(storedCache.widgetData);
        return storedCache.widgetData;
      }
    }

    const { payload, widgetData } = await fetchWidgetCache();
    syncWidgetCache(widgetData);
    writeClientCache(payload);
    return widgetData;
  }

  async function getFngYearData(forceRefresh) {
    if (!forceRefresh && cachedFngYear) return cachedFngYear;
    const widgetData = await getWidgetData(forceRefresh);
    return (
      widgetData.fear_greed ||
      widgetData.fearGreed || { latest: null, series: [] }
    );
  }

  async function refreshSummaryData(forceRefresh) {
    const fngYear = await getFngYearData(forceRefresh);
    renderSummary(fngYear);
    return fngYear;
  }

  async function getCoinDailyPrices(coin) {
    const cached = cachedDailyPricesByCoin.get(coin);
    if (cached) return cached;
    const widgetData = await getWidgetData(false);
    const raw = widgetData.prices?.[coin] || [];
    const filtered = (Array.isArray(raw) ? raw : [])
      .map((p) => ({ time: Number(p?.time), price: Number(p?.price) }))
      .filter(
        (p) =>
          Number.isFinite(p.time) && Number.isFinite(p.price) && p.time > 0,
      );

    // store filtered series (may be empty) to avoid repeated work
    cachedDailyPricesByCoin.set(coin, filtered);
    return filtered;
  }

  async function drawChart() {
    const fngYear = await getFngYearData(false);
    const days = daysByPeriod(currentPeriod);
    const dailyPricesFull = await getCoinDailyPrices(currentCoin);
    const fngRaw = Array.isArray(fngYear?.series) ? fngYear.series : [];
    const periodFngRaw = fngRaw.slice(-days);
    const periodFng = periodFngRaw
      .map((p) => ({ value: Number(p?.value), time: Number(p?.time) }))
      .filter(
        (p) =>
          Number.isFinite(p.time) && Number.isFinite(p.value) && p.time > 0,
      );

    const dailyPrices = Array.isArray(dailyPricesFull)
      ? dailyPricesFull.slice(-days - 2)
      : [];

    if (!periodFng.length || !dailyPrices.length) {
      setChartStateError(getChartErrorMessage(), hasRenderedChart);
      return;
    }

    const alignedSeries = alignDailySeries(periodFng, dailyPrices);
    const chartData = getChartData(alignedSeries);

    clearChartStateError();
    renderChart(chartData, currentCoin, currentPeriod);
    updateLegend(currentCoin);
  }

  async function refreshSummary(forceRefresh) {
    try {
      await refreshSummaryData(forceRefresh);
      return true;
    } catch (error) {
      console.error("[FGI] summary refresh error", { error });
      if (!cachedFngYear) {
        setSummaryStateError(getErrorMessage());
      }
      return false;
    }
  }

  async function redrawChart() {
    try {
      await drawChart();
      return true;
    } catch (error) {
      console.error("[FGI] chart redraw error", {
        period: currentPeriod,
        coin: currentCoin,
        error,
      });
      setChartStateError(getChartErrorMessage(), hasRenderedChart);
      return false;
    }
  }

  async function refreshAll(forceRefresh) {
    const hasSummary = await refreshSummary(forceRefresh);
    if (!hasSummary && !cachedFngYear) {
      setChartStateError(getChartErrorMessage(), hasRenderedChart);
      return;
    }
    await redrawChart();
  }

  async function initializeWidget() {
    const storedCache = readClientCache();

    if (storedCache) {
      syncWidgetCache(storedCache.widgetData);
      await refreshAll(false);

      if (shouldRevalidateClientCache(storedCache)) {
        void refreshAll(true);
      }

      return;
    }

    await refreshAll(true);
  }

  syncCoinSelect(currentCoin);
  if (dom.coinSelect) {
    dom.coinSelect.dataset.open = "false";
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("#chartControls button[data-period]");
    if (button) {
      syncPeriodControls(button);
      currentPeriod = button.dataset.period;
      void redrawChart();
      return;
    }

    const trigger = event.target.closest("#coinSelect .chart-select-trigger");
    if (trigger) {
      if (dom.coinSelect?.classList.contains("open")) {
        closeCoinSelect();
      } else {
        openCoinSelect();
      }
      return;
    }

    const option = event.target.closest("#coinSelect .chart-select-option");
    if (option) {
      selectCoin(option.dataset.value);
      return;
    }

    if (dom.coinSelect && !dom.coinSelect.contains(event.target)) {
      closeCoinSelect();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (!dom.coinSelect) return;
    const isInsideCoinSelect = dom.coinSelect.contains(event.target);
    if (!isInsideCoinSelect) return;

    if (event.key === "Escape") {
      closeCoinSelect();
      dom.coinSelectTrigger?.focus();
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      if (event.target.closest(".chart-select-trigger")) {
        event.preventDefault();
        if (dom.coinSelect.classList.contains("open")) {
          closeCoinSelect();
        } else {
          openCoinSelect();
        }
      }
      return;
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      if (!dom.coinSelect.classList.contains("open")) {
        openCoinSelect();
        return;
      }
      moveCoinSelection(event.key === "ArrowDown" ? 1 : -1);
    }
  });

  void initializeWidget();
  setInterval(() => {
    void refreshAll(true);
  }, FGI_CONFIG.refreshIntervalMs || UI.refreshIntervalMs);
});
